const travelConfig = {
  travel: {
    accommodations: {
      denseViewThreshold: 1,
    },
  },
}

export default travelConfig
